import { Component, OnInit } from '@angular/core';
import { loadingFade, modal, alert } from '../../animacoes';

import { OrdemServicoService } from '../services/ordem-servico.service';

@Component({
  selector: 'app-ordem-servico',
  templateUrl: './ordem-servico.component.html',
  styleUrls: ['./ordem-servico.component.css'],
	animations: [loadingFade, modal, alert]
})
export class OrdemServicoComponent implements OnInit {
  	public loading = false;
	public formularios = [];

	// paginacao
	public page = 1;
	public limit = 10;
	public count = 0;

	// modal
	public modalApagar = 'hidden';
	public idFormularioApagar = null;
	public formularioApagar = '';

	// alert
	public msg_alerta = '';
	public class_alerta = '';
	public flag_alerta = 'hidden';

	constructor(private OrdemServicoSvc: OrdemServicoService) { }

	ngOnInit() {
		this.pegaGruposDespesa();
	}

	pegaGruposDespesa() {
		this.formularios = [];
		this.loading = true;
		this.OrdemServicoSvc.getFormulariosManutencao().then((data: any[]) => {
			this.formularios = data;
			this.count = this.formularios.length;
			this.loading = false;
		}).catch((err) => {
			console.log(err);
			this.loading = false;
		})
	}

	primPagina() {
		this.page = 1;
	}

	paginaAnt() {
		this.page = Math.max(this.page - 1, 1);
	}

	proxPagina() {
		this.page = Math.min(this.page + 1, Math.ceil(this.count / this.limit));
	}

	ultPagina() {
		this.page = Math.ceil(this.count / this.limit);
	}

	perguntaApagar(id) {
		this.modalApagar = 'shown';
		this.idFormularioApagar = id;
	}

	cancelaApagar() {
		this.modalApagar = 'hidden';
	}

	apagaFormulario() {
		this.modalApagar = 'hidden';
		this.loading = true;
		this.OrdemServicoSvc.apagaFormularioManutencao(this.idFormularioApagar).then((data) => {
			this.mostraMsg('Ordem de serviço apagada com sucesso.', 'alert-success');
			this.pegaGruposDespesa();
		}).catch((err) => {
			console.log(err);
			this.mostraMsg('Problema ao apagar ordem de serviço.', 'alert-danger');
			this.loading = false;
		});
	}

	mostraMsg(msg, classe) {
		this.msg_alerta = msg;
		this.class_alerta = classe;
		this.flag_alerta = 'shown';
		setTimeout(() => this.flag_alerta = 'hidden', 10);
	}
}